import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import logoSrc from 'assets/Home/header__logo.svg';
import { desktop } from '../utils/mediaQueries';
import BurgerNavigation from './BurgerNavigation';
const messages = defineMessages({
    partnerWithUs: 'Partner with Us',
    influencer: 'Become an Influencer',
    health: 'Health',
    sweat: 'About SWEAT',
});
const Navbar = ({ children }) => {
    return (_jsxs(Wrapper, { role: "navigation", children: [_jsx(LogoLink, { to: "/", exact: true, children: _jsx("img", { src: logoSrc, alt: "SWT Logo", width: "180", height: "35" }) }), _jsx(BurgerNavigation, { children: children }), _jsxs(Links, { children: [_jsx(FormattedMessage, Object.assign({}, messages.partnerWithUs, { children: (msg) => (_jsx(Link, { href: "https://lp.sweatco.in/partners", rel: "noreferrer noopener", target: "_blank", children: msg })) })), _jsx(FormattedMessage, Object.assign({}, messages.influencer, { children: (msg) => (_jsx(Link, { href: "https://promote.sweatco.in/", rel: "noreferrer noopener", target: "_blank", children: msg })) })), _jsx(FormattedMessage, Object.assign({}, messages.health, { children: (msg) => (_jsx(StyledNavLink, { to: "/health", exact: true, target: "_blank", children: msg })) })), children] })] }));
};
const Wrapper = styled.nav `
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  padding: 20px 16px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  backdrop-filter: blur(15px);
  background-color: rgba(29, 21, 40, 0.09);

  @media ${desktop()} {
    padding: 20px 70px;
  }
`;
const LogoLink = styled(NavLink) `
  width: 142px;
  height: 36px;

  img {
    width: 100%;
    object-fit: contain;
  }
`;
const Links = styled.div `
  transform: translateY(-2px);
  display: none;

  a {
  }

  @media ${desktop()} {
    display: block;
  }
`;
const LinkStyle = css `
  font-family: 'Inter', sans-serif;
  color: #ffffff !important;
  font-size: 14px;
  line-height: 1.4;
  margin-left: 24px;
`;
const StyledNavLink = styled(NavLink) `
  ${LinkStyle}
`;
const Link = styled.a `
  ${LinkStyle}
`;
export default Navbar;
